import { getAmplitudeInstance } from '../amplitudeHelpers';
import SearchOrigin from '../enums/SearchOrigin';

type logNaturalLanguageSuggestedPromptsDisplayedParams = {
  location: SearchOrigin;
  num_prompts?: number;
};

/**
 * NLS suggested prompts being shown to user
 * @param params - Attributes to log with the amplitude event
 * @param params.location - Search origin (e.g., homepage)
 * @param params.num_prompts - How many suggested prompt are shown
 */
const logNaturalLanguageSuggestedPromptsDisplayed = (
  { location, num_prompts }: logNaturalLanguageSuggestedPromptsDisplayedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent('natural language suggested prompts displayed', { location, 'num prompts': num_prompts }, callback);
};

export default logNaturalLanguageSuggestedPromptsDisplayed;
